const rules = function () {
  return {
    delayTime: {
      required: true,
      message: "请选择服务止期延迟",
      trigger: "change",
    },
    startTime: {
      required: true,
      message: "请选择暂停日期开始时间",
      trigger: "change",
    },
    endTime: {
      required: true,
      message: "请选择暂停日期结束时间",
      trigger: "change",
    },
    specialRemark: {
      required: true,
      message: "请输入特别约定",
      trigger: "change",
    },
    enc: {
      required: true,
      message: "请上传附件",
      trigger: "change",
    },
  };
};

module.exports = {
  rules,
};
